export enum EProjectRequestStatus {
  DRAFT = 1,
  ENDORSED = 2,
  ENDORSED_AND_REVISED = 3,
  APPROVED = 4,
  PROCESSED = 5,
  REJECTED = -999,
  CURRENT_PROJECT = 999,
}

export enum EProjectRequestType {
  BUILDING = 1,
  CIVIL = 3,
  FOUNDATIONS = 4,
  E_AND_M = 5,
  CONCRETE = 7,
  STEELWORK = 8,
  TENDER = 9,
}

export enum EProjectRequestRegion {
  HONG_KONG = 1,
  CHINA = 2,
  MACAU = 3,
  SINGAPORE = 4,
}
